import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31dc2186")

_pushScopeId("data-v-31dc2186")
const _hoisted_1 = { class: "choose-project" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "heading-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_FormRow = _resolveComponent("FormRow")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PoweredBy = _resolveComponent("PoweredBy")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", { src: _ctx.logoIcon }, null, 8, ["src"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("span", null, _toDisplayString(_ctx.$t('chooseProject.heading')), 1)
    ]),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode(_component_AutoComplete, {
          control: _ctx.campaign,
          "enable-build-in-search": true,
          "item-text": _ctx.autoCompleteData.itemText,
          "item-value": _ctx.autoCompleteData.itemValue,
          items: _ctx.autoCompleteData.items,
          placeholder: _ctx.$t('chooseProject.selectProject'),
          class: "full-width",
          onItemSelect: _ctx.onCampaignSelect
        }, null, 8, ["control", "item-text", "item-value", "items", "placeholder", "onItemSelect"])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode(_component_Button, {
          disabled: _ctx.inValid,
          class: "full-width",
          size: "large",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmCampaign()))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.signUp')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, null, {
      default: _withId(() => [
        _createVNode(_component_PoweredBy)
      ]),
      _: 1
    })
  ]))
})